<mat-card class=".imc--cap">
  <mat-card-title>
    {{ 'logout.texto.cabecera' | translate }}
  </mat-card-title>
  <mat-card-content>
    {{ 'logout.texto.descripcion' | translate }}
  </mat-card-content>
  <button class="tel-button-icon normal_size" (click)="redirigeALogin()">
    {{ 'logout.boton.reconectar' | translate }}
  </button>
</mat-card>
